<script>
    import SFS2X, { SFSObject, SFSArray } from "sfs2x-api";
    import { onMount, setContext } from 'svelte';
    import UserProfile from '../components/UserProfile.svelte';
    import Chat from '../components/Chat.svelte';
    import casinosStore from '../stores/casinosStore';
    import tablesStore from '../stores/tablesStore';
    import { CHIPS, getSFS, getTableRoom, initSFS, joinTable, leaveTable, PHOTO, PLAYERS, USER_NAME, USER_ID, SIT_OUT, initGlobalSFS, updateLocation } from '../controllers/SFSController';
    import { navigate } from 'svelte-routing';
    import BuyInPanel from "../components/BuyInPanel.svelte";
    import ProfilePanel from "../components/ProfilePanel.svelte";
    import SelectGiftPanel from "../components/SelectGiftPanel.svelte";
    import PokerPlayer from "../components/PokerPlayer.svelte";
    import userStore from '../stores/userStore';
    import { get } from "svelte/store";
    import PokerCard from "../components/PokerCard.svelte";
    import PokerChips from "../components/PokerChips.svelte";
    import { showToast } from "../utils/Toast";
    import {getBestTexasHand, score, scoreToString} from "../controllers/PokerLogic";
    import {currentTable} from "../stores/tablesStore";
    import FriendshipInvitation from "../components/FriendshipInvitation.svelte";
    import friendsStore from "../stores/friendsStore";
    import FriendsPanel from "../components/FriendsPanel.svelte";
    
    export const SIT_AT_TABLE_CMD = "pokerClient.sitAtTable";
    export const STAND_UP_CMD = "pokerClient.standUp";
    export const SIT_OUT_CMD = "pokerClient.sitOut";
    export const PLACE_BET_CMD = "pokerClient.placeBet";
    export const FOLD_CMD = "pokerClient.fold";
    export const FULL_UPDATE_CMD = "pokerClient.fullUpdate";
    export const REVEAL_CARD_CMD = "pokerClient.revealCard";
    export const SHOW_RABBITS_CMD = "pokerClient.showRabbits";
    export const SEND_GIFT_CMD = "pokerClient.sendGift";
    export const SEND_FRIENDSHIP_CMD = "pokerClient.sendFriendship";
    export const ANSWER_FRIENDSHIP_CMD = "pokerClient.answerFriendship";
        
    export const ERROR_MSG = "pokerServer.errorMessage";
    export const SIT_DOWN_MSG = "pokerServer.sitDown";
    export const SIT_OUT_MSG = "pokerServer.sitOut";
    export const STAND_UP_MSG = "pokerServer.standUp";
    export const START_ROUND_MSG = "pokerServer.startRound";
    export const PLAYER_ACTION_MSG = "pokerServer.playerAction";
    export const FLOP_CARDS_MSG = "pokerServer.flopCards";
    export const TURN_CARD_MSG = "pokerServer.turnCard";
    export const RIVER_CARD_MSG = "pokerServer.riverCard";
    export const END_ROUND_MSG = "pokerServer.endRound";
    export const REVEAL_CARD_MSG = "pokerServer.revealCard";
    export const SHOW_RABBITS_MSG = "pokerServer.showRabbits";
    export const FULL_UPDATE_MSG = "pokerServer.fullUpdate";
    export const SEND_GIFT_MSG = "pokerServer.sendGift";
    export const SEND_FRIENDSHIP_MSG = "pokerServer.sendFriendship";
    export const ANSWER_FRIENDSHIP_MSG = "pokerServer.answerFriendship";
    export const UPDATE_BBJP_MSG = "pokerServer.updateBBJP";
    export const AWARD_BBJP_MSG = "pokerServer.awardBBJP";
    
    export let casinoId;
    export let tableId;
    let casinoObj;
    let tableObj;
    let buyInPanel;
    let profilePanel;
    let friendsPanel;
    let selectGiftPanel;
    let friendshipInvitation;
    let selectedSeat;
    let chat;
    let sfs;
    let globalSfs;
    let tableRoom;
    let myPlayer = undefined;
    let activePlayer = undefined;
    let isSitOut = false;
    let minBet = 0;
    let requiredBet = 0;
    let stage = "waiting";
    let isConnected = false;
    let players = [];
    let spectators = [];
    let pots = [];
    let communityCards = [];
    let rabbitCards = [];
    let foldButton;
    let betRaiseButton;
    let checkCallButton;
    let allInButton;
    let foldToggle;
    let checkFoldToggle;
    let checkToggle;
    let callToggle;
    let callAnyToggle;
    let allInToggle;
    let presetCallLimit = 0;
    let betRaiseAmount;
    let autoAction;
    let bestHandDescription = null;
    let bestHandPercent = 0;
    let bbjpAmount = 0;
    let bbjpWon = "";
    let roundOver = false;

    setContext("myPlayer", {
        getMyPlayer: () => myPlayer
    });

    onMount(() => {        
        (async () => {
            casinoObj = await casinosStore.getCasinoById(casinoId);
            tableObj = await tablesStore.getTableById(casinoId, tableId);
            minBet = tableObj.big_blind;
            bbjpAmount = casinoObj.bbjp_amount;
            currentTable.set(tableObj);
            
            //Override SFS host and port in case we're opening this from localhost, to make it work with local SFS
            if(window.location.href.indexOf("localhost") != -1)
            {
                casinoObj.mp_addr = "127.0.0.1";
                casinoObj.mp_port = "8080";
            }
            
            globalSfs = initGlobalSFS();
            sfs = initSFS(casinoObj.mp_addr, casinoObj.mp_port, onLoggedIn);
        })();
        return destroy;
    });

    function destroy()
    {
        setupListeners(false);

        sfs = null;
        globalSfs = null;
    }

    function setupListeners(add)
    {
        if (add)
        {
            sfs.addEventListener(SFS2X.SFSEvent.CONNECTION, onConnected, this);
            sfs.addEventListener(SFS2X.SFSEvent.CONNECTION_LOST, onDisconnected, this);
            sfs.addEventListener(SFS2X.SFSEvent.SPECTATOR_TO_PLAYER, onSpectatorToPlayer, this);
            sfs.addEventListener(SFS2X.SFSEvent.PLAYER_TO_SPECTATOR, onPlayerToSpectator, this);
            sfs.addEventListener(SFS2X.SFSEvent.ROOM_VARIABLES_UPDATE, onRoomUpdate, this);
            sfs.addEventListener(SFS2X.SFSEvent.USER_ENTER_ROOM, onUserEnter, this);
            sfs.addEventListener(SFS2X.SFSEvent.USER_EXIT_ROOM, onUserExit, this);
            sfs.addEventListener(SFS2X.SFSEvent.USER_VARIABLES_UPDATE, onUserUpdate, this);
            sfs.addEventListener(SFS2X.SFSEvent.EXTENSION_RESPONSE, onServerMessage, this);
        }
        else
        {
            sfs.removeEventListener(SFS2X.SFSEvent.CONNECTION, onConnected, this);
            sfs.removeEventListener(SFS2X.SFSEvent.CONNECTION_LOST, onDisconnected, this);
            sfs.removeEventListener(SFS2X.SFSEvent.SPECTATOR_TO_PLAYER, onSpectatorToPlayer, this);
            sfs.removeEventListener(SFS2X.SFSEvent.PLAYER_TO_SPECTATOR, onPlayerToSpectator, this);
            sfs.removeEventListener(SFS2X.SFSEvent.ROOM_VARIABLES_UPDATE, onRoomUpdate, this);
            sfs.removeEventListener(SFS2X.SFSEvent.USER_ENTER_ROOM, onUserEnter, this);
            sfs.removeEventListener(SFS2X.SFSEvent.USER_EXIT_ROOM, onUserExit, this);
            sfs.removeEventListener(SFS2X.SFSEvent.USER_VARIABLES_UPDATE, onUserUpdate, this);
            sfs.removeEventListener(SFS2X.SFSEvent.EXTENSION_RESPONSE, onServerMessage, this);
        }
    }

    //---------------------------------------------------------------------------------------------------

    function onLoggedIn()
    {
        joinTable(tableId, casinoId, onJoinedTable);
    }

    function onJoinedTable()
    {
        sfs = getSFS();
        tableRoom = getTableRoom();
        
        setupListeners(true);
        onConnected();

        if(chat)
            chat.registerEvents();

        requestFullUpdate();
        updateLocation({casino: casinoId, table: tableId});
        //demoData();
        //players[1].setPlayerData({userId: "cc0000000001", username: "Val1", photo: "https://mpng.subpng.com/20180420/eye/kisspng-bad-piggies-hd-angry-birds-rovio-entertainment-minority-vector-5ada56565c21d0.6437063415242583903774.jpg", chips: 100});
        //setTimeout(testStuff, 100);
    }
    
    /*function testStuff()
    {
        communityCards[0].setCardValue("TS");
        communityCards[1].setCardValue("JS");
        communityCards[2].setCardValue("QS");
        communityCards[3].setCardValue("KS");
        communityCards[4].setCardValue("KC");

        
        players[1].setCards("9S", "9D");

        let cards = [players[1].getCards()[0], players[1].getCards()[1]];
        for(let i = 0; i<5; i++)
            if (communityCards[i].getCardValue())
                cards.push(communityCards[i]);

        let bestHand = getBestTexasHand(cards, cards.length);

        console.log(bestHand);
        bestHandDescription = scoreToString(score(bestHand));
    }*/

    /*function demoData()
    {
        players[1].setPlayerData({userId: "cc0000000001", username: "Val1", photo: "https://mpng.subpng.com/20180420/eye/kisspng-bad-piggies-hd-angry-birds-rovio-entertainment-minority-vector-5ada56565c21d0.6437063415242583903774.jpg", chips: 100});
        players[2].setPlayerData({userId: "cc0000000002", username: "Val2", photo: "https://mpng.subpng.com/20180420/eye/kisspng-bad-piggies-hd-angry-birds-rovio-entertainment-minority-vector-5ada56565c21d0.6437063415242583903774.jpg", chips: 100});
        players[3].setPlayerData({userId: "cc0000000003", username: "Val3", photo: "https://mpng.subpng.com/20180420/eye/kisspng-bad-piggies-hd-angry-birds-rovio-entertainment-minority-vector-5ada56565c21d0.6437063415242583903774.jpg", chips: 100});
        players[4].setPlayerData({userId: "cc0000000004", username: "Val4", photo: "https://mpng.subpng.com/20180420/eye/kisspng-bad-piggies-hd-angry-birds-rovio-entertainment-minority-vector-5ada56565c21d0.6437063415242583903774.jpg", chips: 100});
        players[5].setPlayerData({userId: "cc0000000005", username: "Val5", photo: "https://mpng.subpng.com/20180420/eye/kisspng-bad-piggies-hd-angry-birds-rovio-entertainment-minority-vector-5ada56565c21d0.6437063415242583903774.jpg", chips: 100});
        if (tableObj.num_players > 5)
        {
            players[6].setPlayerData({userId: "cc0000000006", username: "Val6", photo: "https://mpng.subpng.com/20180420/eye/kisspng-bad-piggies-hd-angry-birds-rovio-entertainment-minority-vector-5ada56565c21d0.6437063415242583903774.jpg", chips: 100});
            players[7].setPlayerData({userId: "cc0000000007", username: "Val7", photo: "https://mpng.subpng.com/20180420/eye/kisspng-bad-piggies-hd-angry-birds-rovio-entertainment-minority-vector-5ada56565c21d0.6437063415242583903774.jpg", chips: 100});   
            players[8].setPlayerData({userId: "cc0000000008", username: "Val8", photo: "https://mpng.subpng.com/20180420/eye/kisspng-bad-piggies-hd-angry-birds-rovio-entertainment-minority-vector-5ada56565c21d0.6437063415242583903774.jpg", chips: 100});
        }
        
        communityCards[0].setCardValue("3D");
        communityCards[1].setCardValue("5S");
        communityCards[2].setCardValue("JS");
        communityCards[3].setCardValue("AH");
        communityCards[4].setCardValue("QC");

        pots[0].setAmount(1);
        pots[1].setAmount(2);
        pots[2].setAmount(3);
        pots[3].setAmount(4);
        pots[4].setAmount(5);
        if (tableObj.num_players > 5)
        {
            pots[5].setAmount(6);
            pots[6].setAmount(7);
            pots[7].setAmount(8);
        }

        setTimeout(()=> {
            players[1].setCards("4H", "7S");
            players[2].setCards("4H", "7S");
            players[3].setCards("4H", "7S");
            players[4].setCards("4H", "7S");
            players[5].setCards("4H", "7S");
            if (tableObj.num_players > 5)
            {
                players[6].setCards("4H", "7S");
                players[7].setCards("4H", "7S");
                players[8].setCards("4H", "7S");
            }

            players[1].setBet(10);
            players[2].setBet(10);
            players[3].setBet(10);
            players[4].setBet(10);
            players[5].setBet(10);
            if (tableObj.num_players > 5)
            {
                players[6].setBet(10);
                players[7].setBet(10);
                players[8].setBet(10);
            }

            players[1].setDealer(true);
            players[2].setDealer(true);
            players[3].setDealer(true);
            players[4].setDealer(true);
            players[5].setDealer(true);
            if (tableObj.num_players > 5)
            {
                players[6].setDealer(true);
                players[7].setDealer(true);
                players[8].setDealer(true);
            }

            players[5].setActive(true);
        }, 100);
    }*/

    //---------------------------------------------------------------------------------------------------

    function onConnected()
    {
        console.log("onConnected");
        isConnected = true;
    }

    function onDisconnected()
    {
        console.log("onDisconnected");
        isConnected = false;
    }

    function onSpectatorToPlayer(e)
    {
        console.log("onSpectatorToPlayer");
        updateSpectators();
    }

    function onPlayerToSpectator(e)
    {
        console.log("onPlayerToSpectator");
        updateSpectators();
    }

    function onRoomUpdate(e)
    {
        console.log("onRoomUpdate");
    }

    function onUserEnter(e)
    {
        console.log("onUserEnter");
        updateSpectators();
    }

    function onUserExit(e)
    {
        console.log("onUserExit");
        updateSpectators();
    }

    function onUserUpdate(e)
    {
        console.log("onUserUpdate");

        if (get(userStore).user_id == e.user.name)
            userStore.update(user => { user.balance = e.user.getVariable("balance").value; return user;});
    }

    function onServerMessage(e)
    {
        console.log("onServerMessage: " + e.cmd);

        switch(e.cmd)
        {
            case ERROR_MSG:
                serverError(e.params);
                break;
            case SIT_DOWN_MSG:
                sitDown(e.params);
                break;
            case SIT_OUT_MSG:
                sitOut(e.params);
                break;            
            case STAND_UP_MSG:
                standUp(e.params);
                break;
            case START_ROUND_MSG:
                startRound(e.params);
                break;
            case PLAYER_ACTION_MSG:
                playerAction(e.params);
                break;
            case FLOP_CARDS_MSG:
                flopCards(e.params);
                break;
            case TURN_CARD_MSG:
                turnCard(e.params);
                break;
            case RIVER_CARD_MSG:
                riverCard(e.params);
                break;
            case END_ROUND_MSG:
                endRound(e.params);
                break;
            case REVEAL_CARD_MSG:
                checkHoleCardsRevealed(e.params);
                break;
            case SHOW_RABBITS_MSG:
                showRabbits(e.params);
                break;
            case FULL_UPDATE_MSG:
                fullUpdate(e.params);
                break;
            case SEND_GIFT_MSG:
                sendGift(e.params);
                break;
            case SEND_FRIENDSHIP_MSG:
                friendInvite(e.params);
                break;
            case ANSWER_FRIENDSHIP_MSG:
                answerInvite(e.params);
                break;
            case UPDATE_BBJP_MSG:
                updateBBJP(e.params);
                break;
            case AWARD_BBJP_MSG:
                setTimeout(() => { awardBBJP(e.params) }, 5500);
                break;
        }
    }

    //---------------------------------------------------------------------------------------------------

    function notConnectedError()
    {
        showToast("ERROR: Not connected to SFS", null);
    }

    function serverError(params)
    {
        chat.logEvent("Server error: " + params.getUtfString("error") + "[" + params.getInt("errorCode") + "]");
        showToast(params.getUtfString("error"), null);
        

        switch(params.getInt("errorCode"))
        {
            case 3: //SEAT_OCCUPIED
            case 9: //INVALID_BUY_IN
                showSitButtons(true);
                break;
        }
    }

    function sitDown(params)
    {
        updatePlayers(params);
    }

    function sitOut(params)
    {
        let playerId = params.getUtfString("playerId");
        let sitOut = params.getBool("sitOut");

        chat.logEvent(playerId + (sitOut ? " sit out" : " sit in"));

        for(let player of players)
            if (player && player.getUserId() == playerId)
            {
                player.setSitOut(sitOut);
                if (player == myPlayer)
                    isSitOut = sitOut;
            }
    }

    function standUp(params)
    {
        updatePlayers(params);
    }

    function setActivePlayer(activeSeat, timeLeft = 0)
    {
        let newActivePlayer = players[activeSeat];
        if (activePlayer)
            activePlayer.setActive(false);
        if (newActivePlayer)
            newActivePlayer.setActive(true, onActionTimeout, timeLeft);
        activePlayer = newActivePlayer;

        if (activePlayer)
            chat.logEvent("Active player: " + activePlayer.getUserName());

        if (autoAction != null && activePlayer == myPlayer) //my turn has come and I have an auto-action already preset
        {
            setTimeout(() => {
                if (myPlayer && sfs)    //check that I'm still playing and we haven't exited to Lobby
                {
                    if (autoAction == "fold")
                        requestFold();
                    if (autoAction == "checkFold")
                    {
                        if(requiredBet == 0 || myPlayer.getBet() == requiredBet)
                            requestCheck();
                        else
                            requestFold();
                    }
                    if (autoAction == "check")
                        requestCheck();
                    if (autoAction == "call")
                        requestCall(presetCallLimit);
                    if (autoAction == "callAny")
                        requestCall();
                    if (autoAction == "allIn")
                        requestAllIn();

                    autoAction = null;  //clear auto-action once executed, so we can get our controls if the autoaction has failed due to some limit (call or check)
                }
            }, 1000);
        }
    }

    function onActionTimeout()
    {
        if (activePlayer == myPlayer && myPlayer && sfs)   //it's my turn now and my own timer just ended - and I'm still playing and haven't exited to Lobby
        {
            if (requiredBet == 0 || requiredBet == myPlayer.getBet())
                requestCheck();
            else
                requestFold();
        }
    }

    function updatePots(potValues)
    {
        for(let player of players)
            if (player)
                player.setBet(0);
        
        if (potValues && potValues.length > 0)
        {
            for(let i = 0; i<pots.length; i++)
            {
                if (potValues[i])
                {
                    pots[i].setAmount(potValues[i]);
                    chat.logEvent("Pot " + i + ": " + potValues[i]);
                }
                else
                    pots[i].setAmount(0);
            }
        }
        else
        {
            for(let i = 0; i<pots.length; i++)
                pots[i].setAmount(0);
        }
    }

    function clearCommunityCards()
    {
        for(let i = 0; i < 5; i++)
            if (communityCards && communityCards[i])
            {
                communityCards[i].setCardValue(null);
                communityCards[i].setHidden(true);
            }
    }

    function startRound(params)
    {
        stage = params.getUtfString("stage");

        chat.logEvent("Start new round. Dealer seat: " + params.getInt("dealerSeat"));
        
        roundOver = false;
        resetStatuses(true);

        for(let player of players)
            if (player)
            {
                player.setDealer(player.getSeatNo() == params.getInt("dealerSeat"));

                if (params.getSFSObject("players").containsKey(player.getSeatNo().toString()))
                {
                    let sfsPlayer = params.getSFSObject("players").getSFSObject(player.getSeatNo().toString());
                    player.setPlaying(true);
                    player.setChips(sfsPlayer.getDouble("chips"));
                    player.setBet(sfsPlayer.getDouble("bet"));
                    player.setStatus(sfsPlayer.getUtfString("status"));
                }

                let holeCards = params.getUtfStringArray("holeCards");
                if (player == myPlayer && holeCards)
                    player.setCards(holeCards[0], holeCards[1]);
                else if (player.isPlaying())
                    player.setCards(null, null);
                else 
                    player.clearCards();
            }
        
        minBet = params.getDouble("minBet");
        requiredBet = params.getDouble("requiredBet");
        chat.logEvent("requiredToCall: " + requiredBet + ", minBet: " + minBet);
        autoAction = null;

        clearCommunityCards();
        updateBestHand();
        
        setActivePlayer(params.getInt("activePlayer"));
    }
    
    function playerAction(params)
    {
        let player = players[params.getInt("playerSeat")];
        let betDiff = params.getDouble("betAmount") - player.getBet();
        player.setBet(params.getDouble("betAmount"));
        player.setChips(params.getDouble("chips"));
        player.setStatus(params.getUtfString("status"));
        if (player.getStatus() == "fold")
            player.foldCards();

        chat.logEvent(player.getUserName() + " " + params.getUtfString("status") + " " +  (betDiff > 0 ? betDiff : ""));

        minBet = params.getDouble("minBet");
        requiredBet = params.getDouble("requiredBet");

        chat.logEvent("requiredToCall: " + requiredBet + ", minBet: " + minBet);
        
        setActivePlayer(params.getInt("activePlayer"));
    }

    function flopCards(params)
    {
        stage = params.getUtfString("stage");
        minBet = tableObj.big_blind;
        requiredBet = 0;
        autoAction = null;

        setActivePlayer(params.getInt("activePlayer"));

        let flopCards = params.getUtfStringArray("flopCards");
        communityCards[0].setCardValue(flopCards[0]);
        communityCards[1].setCardValue(flopCards[1]);
        communityCards[2].setCardValue(flopCards[2]);

        chat.logEvent("Flop cards: " + flopCards[0] + " " + flopCards[1] + " " + flopCards[2]);

        updatePots(params.getDoubleArray("pots"));
        resetStatuses();
        updateBestHand();
        checkReturnChips(params);
        checkHoleCardsRevealed(params);
    }

    function turnCard(params)
    {
        stage = params.getUtfString("stage");
        minBet = tableObj.big_blind;
        requiredBet = 0;
        autoAction = null;

        setActivePlayer(params.getInt("activePlayer"));

        let turnCard = params.getUtfString("turnCard");
        communityCards[3].setCardValue(turnCard);

        chat.logEvent("Turn card: " + turnCard);

        updatePots(params.getDoubleArray("pots"));
        resetStatuses();
        updateBestHand();
        checkReturnChips(params);
        checkHoleCardsRevealed(params);
    }

    function riverCard(params)
    {
        stage = params.getUtfString("stage");
        minBet = tableObj.big_blind;
        requiredBet = 0;
        autoAction = null;

        setActivePlayer(params.getInt("activePlayer"));

        let riverCard = params.getUtfString("riverCard");
        communityCards[4].setCardValue(riverCard);

        chat.logEvent("River card: " + riverCard);

        updatePots(params.getDoubleArray("pots"));
        resetStatuses();
        updateBestHand();
        checkReturnChips(params);
        checkHoleCardsRevealed(params);
    }

    function endRound(params)
    {
        stage = params.getUtfString("stage");

        chat.logEvent("End round");

        setActivePlayer(params.getInt("activePlayer"));

        updatePots(params.getDoubleArray("pots"));
        resetStatuses();
        checkReturnChips(params);

        roundOver = true;
        checkHoleCardsRevealed(params);
        
        setTimeout(() =>    //delay pots distribution to observe last pots values
        {
            if (params && sfs)  //check that I haven't exited to Lobby
            {
                let sfsFinalPots = params.getSFSArray("winners");
                for (let i = 0; i<sfsFinalPots.size(); i++)
                {
                    let sfsPotWinners = sfsFinalPots.getSFSArray(i);
                    setTimeout(() => { showPotWinners(i, sfsPotWinners); }, 5000 * i);
                }

                setTimeout(() => { checkNoChips(); }, 5000 * sfsFinalPots.size());
            }
        }, 3000);
    }

    function showPotWinners(potNo, sfsPotWinners)
    {
        if (sfsPotWinners && sfs)   //check that I haven't exited to Lobby
            for(let j = 0; j<sfsPotWinners.size(); j++)
            {
                let sfsWinner = sfsPotWinners.getSFSObject(j);
                if (sfsWinner)
                {
                    let winnerId = sfsWinner.getUtfString("winnerId");
                    let amount = sfsWinner.getDouble("amount");
                    let bestHand = sfsWinner.getUtfStringArray("bestHand");

                    for(let player of players)
                        if (player)
                        {
                            if (player.getUserId() == winnerId)
                            {
                                player.winChips(amount);
                                player.setStatus("winner");
                                chat.logEvent("Winner " + player.getUserName() + ": " + amount);

                                highlightHand(bestHand, communityCards.concat(player.getCards()));
                            }
                            else
                                highlightHand([], player.getCards());   //clear other player's hole cards highlights when showing the current pot winner
                        }
                }
            }

        if (pots[potNo])
            pots[potNo].setAmount(0);   //clear pot
    }

    function highlightHand(bestHand, cards)
    {
        for(let card of cards)
            if (card)
            {
                if (bestHand.length == 5 && bestHand.indexOf(card.getCardValue()) != -1)
                card.highlight(true);
            else
                card.highlight(false);
            }
    }

    function checkNoChips()
    {
        if (myPlayer && myPlayer.getChips() <= 0)
            onSitDown({detail: {seatNo: myPlayer.getSeatNo()}})
    }

    //-----------------------------------------------------------------------

    function fullUpdate(params)
    {
        updatePlayers(params);        //must call setPlayerData on the occupied seats first, to construct the HTML elements inside PokerPlayer
        updateSpectators();
        setTimeout(() => { updateRound(params); }, 10);      //only then can we call other methods for bets, cards etc.
    }

    function updatePlayers(params)
    {
        console.log("updatePlayers");
        let sfsPlayers = params.getSFSObject("players");

        let foundMyPlayer = false;
        for(let player of players)
            if (player)
            {
                let sfsPlayer = sfsPlayers.getSFSObject(player.getSeatNo().toString());
                if (sfsPlayer && sfsPlayer.getUtfString(USER_ID) == get(userStore).user_id)
                {
                    setMyPlayer(player.getSeatNo());
                    foundMyPlayer = true;
                    break;
                }
            }

        if (!foundMyPlayer)
            setMyPlayer(0);

        for(let player of players)
            if (player)
            {
                let sfsPlayer = sfsPlayers.getSFSObject(player.getSeatNo().toString());

                if (sfsPlayer)
                {
                    player.setPlayerData({ 
                        userId: sfsPlayer.getUtfString(USER_ID),
                        username: sfsPlayer.getUtfString(USER_NAME),
                        photo: sfsPlayer.getUtfString(PHOTO),
                        chips: sfsPlayer.getDouble(CHIPS)
                    });
                    player.setPlaying(sfsPlayer.getBool("playing"));
                    player.setSitOut(sfsPlayer.getBool("sitOut"))

                    let activeGifts = sfsPlayer.getUtfStringArray("activeGifts");
                    if (activeGifts)
                        for(let gift of activeGifts)
                            player.showGift(gift);
                }
                else
                    player.setPlayerData(null);
            }

        if (myPlayer && myPlayer.isSitOut())
            isSitOut = true;
    }

    function updateRound(params)
    {
        if (!sfs)       //check that I haven't exited to Lobby
            return; 
        
        let sfsPlayers = params.getSFSObject("players");
        let sfsRound = params.getSFSObject("round");
        let sfsHoleCards;
        let sfsCommunityCards;
        if (sfsRound)
        {
            sfsHoleCards = sfsRound.getUtfStringArray("holeCards");
            sfsCommunityCards = sfsRound.getUtfStringArray("communityCards");
            stage = sfsRound.getUtfString("stage");
            minBet = sfsRound.getDouble("minBet");
            requiredBet = sfsRound.getDouble("requiredBet");
            autoAction = null;

            updatePots(sfsRound.getDoubleArray("pots"));  //call before setting player bets, as this will delete the bets
        }
        else
            clearCommunityCards();

        for(let player of players)
            if (player)
            {
                let sfsPlayer = sfsPlayers.getSFSObject(player.getSeatNo().toString());

                if (sfsRound)
                {
                    player.setDealer(player.getSeatNo() == sfsRound.getInt("dealerSeat"));

                    if (sfsPlayer)
                    {
                        player.setBet(sfsPlayer.getDouble("bet"));
                        player.setStatus(sfsPlayer.getUtfString("status"));
                    }
                
                    if (player == myPlayer && sfsHoleCards)
                        player.setCards(sfsHoleCards[0], sfsHoleCards[1]);
                    else if (sfsPlayer)
                    {
                        if (sfsPlayer.containsKey("holeCards"))
                        {
                            let cards = sfsPlayer.getUtfStringArray("holeCards");
                            if (cards)
                                player.setCards(cards[0], cards[1]);
                        }
                        else
                            player.setCards(null, null);
                    }
                    else
                        player.clearCards();
                }
                else
                {
                    player.clearCards();
                    player.setStatus("waiting");
                }
            }

        if (sfsCommunityCards)
            for (let i=0; i<sfsCommunityCards.length; i++)
                communityCards[i].setCardValue(sfsCommunityCards[i]);

        if (sfsRound)
        {
            setActivePlayer(sfsRound.getInt("activePlayer"), sfsRound.getInt("actionTimeLeft"));
            updateBestHand();
        }
    }

    function updateSpectators()
    {
        let newSpectators = [];
        let sfsRoom = getTableRoom();
        let sfsSpectators = sfsRoom.getSpectatorList();

        for(let sfsSpectator of sfsSpectators)
        {
            let name = sfsSpectator.getVariable("userName").value;
            let photo = sfsSpectator.getVariable("photo").value;
            newSpectators.push({id: sfsSpectator.name, name: name, photo: photo});
        }

        spectators = newSpectators;
    }

    function resetStatuses(newRound = false)
    {
        for(let player of players)
            if (player)
                if ((player.getStatus() != "fold" && player.getStatus() != "allIn") || newRound)
                    player.setStatus("waiting");
    }

    function checkHoleCardsRevealed(params)
    {
        if (params.containsKey("holeCards") && params.getSFSArray("holeCards"))
        {
            let holeCards = params.getSFSArray("holeCards");
            for(let i = 0; i<holeCards.size(); i++)
            {
                let playerCards = holeCards.getSFSObject(i);
                let seat = playerCards.getInt("seat");
                let firstCard = playerCards.getUtfString("firstCard");
                let secondCard = playerCards.getUtfString("secondCard");
                let scheduledReveal = playerCards.getBool("scheduledReveal");
                
                if (seat && (!myPlayer || seat != myPlayer.getSeatNo()))   //can't override my own cards with the reveal
                {
                    if (roundOver)
                        setTimeout(() => {players[seat].setCards(firstCard, secondCard, scheduledReveal);}, 2000 * i);
                    else
                        players[seat].setCards(firstCard, secondCard, scheduledReveal);
                }
            }
        }
    }

    function showRabbits(params)
    {
        let cards = params.getUtfStringArray("rabbitCards");
        for(let i = 0; i<cards.length; i++)
            rabbitCards[i].setCardValue(cards[i]);

        setTimeout(()=>{
            for(let i = 0; i<rabbitCards.length; i++)
                rabbitCards[i].setHidden(true);
        }, 3000);
    }

    function checkReturnChips(params)
    {
        if (params.containsKey("returnChips") && params.getSFSArray("returnChips"))
        {
            let returnChips = params.getSFSArray("returnChips");
            for(let i = 0; i<returnChips.size(); i++)
            {
                let sfsReturn = returnChips.getSFSObject(i);
                let beneficiary = sfsReturn.getUtfString("playerId");
                let amount = sfsReturn.getDouble("amount");

                for(let player of players)
                    if (player)
                    {
                        if (player.getUserId() == beneficiary)
                        {
                            player.winChips(amount);
                            chat.logEvent("Chips returned to " + player.getUserName() + ": " + amount);
                        }
                    }
            }
        }
    }

    function sendGift(params)
    {
        for(let player of players)
            if (player && player.getSeatNo() == params.getInt("seatNo"))
                player.showGift(params.getUtfString("gift"));
    }

    function friendInvite(params)
    {
        console.log("friendInvite");
        let senderId = params.getUtfString("sender");
        let username = null;
        for(let player of players)
            if (player && player.getUserId() == senderId)
                username = player.getUserName();

        if (username)
            friendshipInvitation.show({userName: username, userId: senderId});
    }

    function answerInvite(params)
    {
        console.log("answerInvite");
        let senderSfs = params.getSFSObject("sender");
        let recipientSfs = params.getSFSObject("recipient");
        let answer = params.getUtfString("answer");
        
        let myFriend = (senderSfs.getUtfString("userId") == get(userStore).user_id) ? recipientSfs : senderSfs;
        
        if (answer == "accept")
        {
            //Update friends storage to include the new friend
            friendsStore.update(friendsData => { 
                friendsData.friends.push({
                    uid: myFriend.getUtfString("userId"), 
                    name: myFriend.getUtfString("userName"),
                    pic: myFriend.getUtfString("photo")
                }); 
                friendsData.friendIds.push( myFriend.getUtfString("userId"));
                return friendsData;
            });
            showToast("You are now friends with " + myFriend.getUtfString("userName"));
        }

        if (answer == "reject")
        {
            showToast(myFriend.getUtfString("userName") + " declined your invitation");
        }

        if (answer == "block")
        {
            if (myFriend == senderSfs)
            {
                //Update friends storage to include the new block
                friendsStore.update(friendsData => { 
                    friendsData.blocked_invites.push({
                        uid: myFriend.getUtfString("userId"), 
                        name: myFriend.getUtfString("userName"),
                        pic: myFriend.getUtfString("photo")
                    }); 
                    friendsData.blockedIds.push(myFriend.getUtfString("userId")); 
                    return friendsData;
                });
            }
            else
                showToast(myFriend.getUtfString("userName") + " declined and blocked your invitations");
        }
    }

    function updateBBJP(params)
    {
        bbjpAmount = params.getDouble("bbjpAmount");
    }

    function awardBBJP(params)
    {
        chat.logEvent("BAD BEAT JACKPOT");
        let losersSFS = params.getSFSArray("losers");
        for (let i = 0; i<losersSFS.size(); i++)
        {
            let loserSFS = losersSFS.get(i);
            let userId = loserSFS.getUtfString("userId");
            let prize = loserSFS.getDouble("prize");
            getPlayerById(userId)?.awardBBJP(prize);
            chat.logEvent(userId + ": " + prize);
        }

        let winnersSFS = params.getSFSArray("winners");
        for (let i = 0; i<winnersSFS.size(); i++)
        {
            let winnerSFS = winnersSFS.get(i);
            let userId = winnerSFS.getUtfString("userId");
            let prize = winnerSFS.getDouble("prize");
            getPlayerById(userId)?.awardBBJP(prize);
            chat.logEvent(userId + ": " + prize);
        }

        let othersSFS = params.getSFSArray("others");
        for (let i = 0; i<othersSFS.size(); i++)
        {
            let otherSFS = othersSFS.get(i);
            let userId = otherSFS.getUtfString("userId");
            let prize = otherSFS.getDouble("prize");
            getPlayerById(userId)?.awardBBJP(prize);
            chat.logEvent(userId + ": " + prize);
        }

        bbjpWon = "BAD BEAT JACKPOT";
        setTimeout(()=>{ bbjpWon = ""; }, 3000);
    }

    //---------------------------------------------------------------------------------------------------

    function setMyPlayer(mySeatNo)
    {
        if ((players.length - 1) % 2 == 1)    //rotate seats for odd number of seats at the table
        {
            if (mySeatNo == 0)  //revert seat numbers to server standard view
            {
                let standardPlayers = [];
                for(let i=1; i<players.length; i++)
                {
                    players[i].setSeatNo(players[i].getOriginalSeatNo(), tableObj.num_players);
                    standardPlayers[players[i].getSeatNo()] = players[i];
                }
                players = standardPlayers;
            }
            else
            {
                let middleBottomSeat = Math.floor((players.length - 1)/2) + 1;
                let diff = middleBottomSeat - mySeatNo;     //how many places to rotate, clock-wise (negative number for counter-clock-wise)

                let rotatedPlayers = [];
                for(let i=1; i<players.length; i++)
                {
                    players[i].setSeatNo(players[i].getOriginalSeatNo() - diff, tableObj.num_players);
                    rotatedPlayers[players[i].getSeatNo()] = players[i];
                    console.log(players[i].getSeatNo() + " | " + players[i].getOriginalSeatNo());
                }
                players = rotatedPlayers;
            }
        }

        if (mySeatNo > 0)
        {
            myPlayer = players[mySeatNo];
            showSitButtons(false);
        }
        else
        {
            myPlayer = null;
            showSitButtons(true);
        }
    }

    function getPlayerById(playerId)
    {
        for(let player of players)
            if (player && player.getUserId() == playerId)
                return player;
        
        return null;
    }

    /*function updatePlayersLocally()
    {
        let sfsPlayers = new SFSObject();

        for(let player of players)
            if (player && player.getUserName())
            {
                let sfsPlayer = new SFSObject();
                sfsPlayer.putUtfString(USER_NAME, player.getUserName().toString());
                sfsPlayer.putUtfString(PHOTO, player.getPhoto().toString());
                sfsPlayer.putDouble(CHIPS, player.getChips());

                sfsPlayers.putSFSObject(player.getOriginalSeatNo().toString(), sfsPlayer);
            }

        let params = new SFSObject();
        params.putSFSObject("players", sfsPlayers);

        updatePlayers(params);
    }

    function getPlayerByOriginalSeatNo(seatNo)
    {
        for(let player of players)
            if (player && player.getOriginalSeatNo() == seatNo)
                return player;
        return null;
    }*/

    function onSitDown(event)
    {
        selectedSeat = event.detail.seatNo;

        showSitButtons(false);
        buyInPanel.show();
    }

    function onReveal(event)
    {
        let userId = event.detail.userId;
        let holeCardIndex = parseInt(event.detail.cardIndex);
        let revealed = (event.detail.revealed == "true" || event.detail.revealed == true ) ? true : false;
       
        if(myPlayer != null && myPlayer.getUserId() == userId)  //I must be the player who requests a card reveal
            requestReveal(holeCardIndex, revealed);
    }

    function onSendGift(event)
    {
        selectedSeat = event.detail.seatNo;
        selectGiftPanel.show();
    }

    function onGiftSelected(event)
    {
        let params = new SFSObject();
        params.putInt("seatNo", selectedSeat);
        params.putUtfString("gift", event.detail.gift);
        params.putDouble("price", event.detail.price);
        params.putUtfString("receipt", event.detail.receipt);

        if (getSFS().isConnected)
            getSFS().send(new SFS2X.ExtensionRequest(SEND_GIFT_CMD, params));   //request to send a gift to a player (possibly yourself)
        else
            notConnectedError();
    }

    function onBuyIn(event)
    {
        let params = new SFSObject();
        params.putInt("seatNo", selectedSeat);
        params.putDouble("buyInAmount", event.detail.buyInAmount);
        params.putBool("autoReBuy", event.detail.autoReBuy);
        params.putBool("autoTopOff", event.detail.autoTopOff);

        if (getSFS().isConnected)
            getSFS().send(new SFS2X.ExtensionRequest(SIT_AT_TABLE_CMD, params));   //request to join a table room as player, with passed seatNo and buyInAmount
        else
        {
            notConnectedError();
            showSitButtons(true);
        }
    }

    function showSitButtons(value)
    {
        for(let player of players)
            if (player)
                player.showSitButton(value);

        if (value == true && myPlayer != null)  //I was already seated, had zero chips and refused to re-buy
            requestLeaveTable();
    }

    function requestLeaveTable()
    {
        leaveTable();
        navigate("/" + casinoId + "/lobby");
    }

    function requestStandUp()
    {
        if (getSFS().isConnected)
        {
            sfs.send(new SFS2X.ExtensionRequest(STAND_UP_CMD, null));   //request to stand up from the table and become a spectator again
            isSitOut = false;
        }
        else
            notConnectedError();
    }

    function requestSitOut()
    {
        isSitOut = !isSitOut;

        let params = new SFSObject();
        params.putBool("sitOut", isSitOut);

        if (getSFS().isConnected)
            sfs.send(new SFS2X.ExtensionRequest(SIT_OUT_CMD, params));  //request to sit out or get back in
        else
            notConnectedError();
    }

    function requestCheck()
    {
        if (requiredBet == 0 || requiredBet == myPlayer.getBet())
        {
            let params = new SFSObject();
            params.putDouble("amount", 0);

            if (getSFS().isConnected)
                getSFS().send(new SFS2X.ExtensionRequest(PLACE_BET_CMD, params));
            else
                notConnectedError();

            myPlayer.clearCountDown();
        }
    }

    function requestCall(limit = -1)
    {
        let betAmount = requiredBet - myPlayer.getBet();
        if (betAmount > myPlayer.getChips())
            betAmount = myPlayer.getChips();
        if (limit > 0 && betAmount > limit)
            return; //don't call if a limit was set and we would need to surpass it

        let params = new SFSObject();
        params.putDouble("amount", betAmount);

        if (getSFS().isConnected)
            getSFS().send(new SFS2X.ExtensionRequest(PLACE_BET_CMD, params));
        else
            notConnectedError();

        myPlayer.clearCountDown();
    }

    function requestBetRaise()
    {
        let betAmount = parseInt(betRaiseAmount.value);
        if (betAmount > myPlayer.getChips())
            betAmount = myPlayer.getChips();

        let params = new SFSObject();
        params.putDouble("amount", betAmount);

        if (getSFS().isConnected)
            getSFS().send(new SFS2X.ExtensionRequest(PLACE_BET_CMD, params));
        else
            notConnectedError();

        myPlayer.clearCountDown();
    }

    function requestAllIn()
    {
        let betAmount = myPlayer.getChips();

        let params = new SFSObject();
        params.putDouble("amount", betAmount);

        if (getSFS().isConnected)
            getSFS().send(new SFS2X.ExtensionRequest(PLACE_BET_CMD, params));
        else
            notConnectedError();

        myPlayer.clearCountDown();
    }

    function requestFold()
    {
        if (getSFS().isConnected)
            getSFS().send(new SFS2X.ExtensionRequest(FOLD_CMD, null));
        else
            notConnectedError();

        myPlayer.clearCountDown();
    }

    function requestFullUpdate()
    {
        if (getSFS().isConnected)
            getSFS().send(new SFS2X.ExtensionRequest(FULL_UPDATE_CMD, null));
        else
            notConnectedError();
    }

    function requestReveal(cardIndex, revealed)
    {
        console.log(cardIndex);
        let params = new SFSObject();
        params.putInt("cardIndex", cardIndex);
        params.putBool("revealed", revealed);

        if (getSFS().isConnected)
            getSFS().send(new SFS2X.ExtensionRequest(REVEAL_CARD_CMD, params));
        else
            notConnectedError();
    }

    function requestRabbits()
    {
        if (getSFS().isConnected)
            getSFS().send(new SFS2X.ExtensionRequest(SHOW_RABBITS_CMD, null));
        else
            notConnectedError();
    }

    //---------------------------------------------------------------------------------------------------

    function setAutoAction(value, checked)
    {
        if (checked)
        {
            if (foldToggle)
                foldToggle.checked = value == "fold" && checked ? true : false;
            if (checkFoldToggle)
                checkFoldToggle.checked = value == "checkFold" && checked ? true : false;
            if (checkToggle)
                checkToggle.checked = value == "check" && checked ? true : false;
            if (callToggle)
                callToggle.checked = value == "call" && checked ? true : false;
            if (callAnyToggle)
                callAnyToggle.checked = value == "callAny" && checked ? true : false;
            if (allInToggle)
                allInToggle.checked = value == "allIn" && checked ? true : false;
        }

        if (foldToggle && foldToggle.checked)
            autoAction = "fold";
        else if (checkFoldToggle && checkFoldToggle.checked)
            autoAction = "checkFold";
        else if (checkToggle && checkToggle.checked)
            autoAction = "check";
        else if (callToggle && callToggle.checked)
        {
            autoAction = "call";
            presetCallLimit = requiredBet;
        }
        else if (callAnyToggle && callAnyToggle.checked)
            autoAction = "callAny";
        else if (allInToggle && allInToggle.checked)
            autoAction = "allIn";
        else
            autoAction = null;

        console.log(autoAction);
    }

    function getMinBet()
    {
        return requiredBet - myPlayer.getBet() + minBet;
    }

    function getMaxBet()
    {
        return myPlayer.getChips();
    }

    function updateBestHand()
    {
        if (!myPlayer || !myPlayer.isPlaying() || !myPlayer.hasCards())
        {
            bestHandPercent = 0;
            bestHandDescription = null;
            return;
        }

        let cards = [myPlayer.getCards()[0], myPlayer.getCards()[1]];
        for(let i = 0; i<5; i++)
            if (communityCards[i].getCardValue())
                cards.push(communityCards[i]);

        let bestHand = getBestTexasHand(cards, cards.length);

        bestHandPercent = (score(bestHand) + 1) * 0.1;
        bestHandDescription = scoreToString(score(bestHand));
    }

    function onViewMyProfile()
    {
        if (profilePanel)
            profilePanel.show(get(userStore));
        if (friendsPanel)
            friendsPanel.hide();
    }

    function onOpenProfilePanel(event)
    {
        if (profilePanel)
            profilePanel.show(event.detail);
        if (friendsPanel)
            friendsPanel.hide();
    }

    function openFriendsPanel()
    {
        if (friendsPanel)
            friendsPanel.show();
        if (profilePanel)
            profilePanel.hide();
    }

    function onSendInvite(event)
    {
        console.log("onSendInvite");

        if(!myPlayer)
        {
            showToast("Must sit at the table to send a friend request");
            return;
        }

        let params = new SFSObject();
        params.putUtfString("recipient", event.detail.user_id);
        
        if (getSFS().isConnected)
            getSFS().send(new SFS2X.ExtensionRequest(SEND_FRIENDSHIP_CMD, params));
        else
            notConnectedError();
    }

    function onInvitationAnswer(answer, originalSender)
    {
        console.log("onFriendAccept");
        let params = new SFSObject();
        params.putUtfString("originalSender", originalSender);
        params.putUtfString("answer", answer);

        if (getSFS().isConnected)
            getSFS().send(new SFS2X.ExtensionRequest(ANSWER_FRIENDSHIP_CMD, params));
        else
            notConnectedError();
    }

</script>

<ion-header>
    <ion-toolbar>
        <div class="hbox">
            <ion-title style="margin-bottom: 60px;">
                {"Casino " + casinoId + " - Table " + tableId}
                {#if isConnected}
                    <span class="sfsConnected">&nbsp;&nbsp;&nbsp;&nbsp; SFS Connected</span>
                {:else}
                    <span class="sfsDisconnected">&nbsp;&nbsp;&nbsp;&nbsp; SFS Disconnected</span>
                {/if}
            </ion-title>
            
            <div class="hbox" style="position: absolute; left: 10px; bottom: 5px;">
                <ion-button on:click={()=>requestLeaveTable()}>Back to Lobby</ion-button>
                {#if myPlayer}
                    <ion-button on:click={()=>requestStandUp()}>Stand up</ion-button>
                    {#if isSitOut}
                        <ion-button on:click={()=>requestSitOut()}>Sit in</ion-button>
                    {:else}
                        <ion-button on:click={()=>requestSitOut()}>Sit out</ion-button>
                    {/if}    
                {/if}
            </div>
            <UserProfile on:editName={onViewMyProfile}/>
        </div>
    </ion-toolbar>
  </ion-header>

<ion-content>
    {#if tableObj}
    <div class="hbox">
        <div class="container">
            <img class="tableImage" src={"/assets/" + tableObj.table_type + ".png"} alt={tableId}>
            <span class="bbjp">Bad Beat Jackpot: {bbjpAmount}</span>
            <span class="bbjpAward">{bbjpWon}</span>

            <div>
            {#if tableObj.table_type == "green_table"}
                <PokerPlayer seatNo=1 bind:this={players[1]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel}/>
                <PokerPlayer seatNo=2 bind:this={players[2]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
                <PokerPlayer seatNo=3 bind:this={players[3]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
                <PokerPlayer seatNo=4 bind:this={players[4]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} /> 
                <PokerPlayer seatNo=5 bind:this={players[5]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
                <PokerPlayer seatNo=6 bind:this={players[6]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
                <PokerPlayer seatNo=7 bind:this={players[7]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
                <PokerPlayer seatNo=8 bind:this={players[8]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
            {/if}

            {#if tableObj.table_type == "red_table"}
                <PokerPlayer seatNo=1 bind:this={players[1]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
                <PokerPlayer seatNo=2 bind:this={players[2]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
                <PokerPlayer seatNo=3 bind:this={players[3]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
                <PokerPlayer seatNo=4 bind:this={players[4]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
                <PokerPlayer seatNo=5 bind:this={players[5]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
                <PokerPlayer seatNo=6 bind:this={players[6]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
                <PokerPlayer seatNo=7 bind:this={players[7]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
                <PokerPlayer seatNo=8 bind:this={players[8]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
            {/if}

            {#if tableObj.table_type == "blue_table"}
                <PokerPlayer seatNo=1 bind:this={players[1]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
                <PokerPlayer seatNo=2 bind:this={players[2]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
                <PokerPlayer seatNo=3 bind:this={players[3]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
                <PokerPlayer seatNo=4 bind:this={players[4]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
                <PokerPlayer seatNo=5 bind:this={players[5]} on:sitDown={onSitDown} on:reveal={onReveal} on:sendGift={onSendGift} on:openProfilePanel={onOpenProfilePanel} />
            {/if} 
            </div>

            <PokerChips bind:this={pots[0]} pot=0 amount=0 />
            <PokerChips bind:this={pots[1]} pot=1 amount=0 />
            <PokerChips bind:this={pots[2]} pot=2 amount=0 />
            <PokerChips bind:this={pots[3]} pot=3 amount=0 />
            <PokerChips bind:this={pots[4]} pot=4 amount=0 />
            <PokerChips bind:this={pots[5]} pot=5 amount=0 />
            <PokerChips bind:this={pots[6]} pot=6 amount=0 />
            <PokerChips bind:this={pots[7]} pot=7 amount=0 />

            <PokerCard bind:this={rabbitCards[0]} cardNo=0 hidden=true rabbit=true/>
            <PokerCard bind:this={rabbitCards[1]} cardNo=1 hidden=true rabbit=true/>
            <PokerCard bind:this={rabbitCards[2]} cardNo=2 hidden=true rabbit=true/>

            <PokerCard bind:this={communityCards[0]} cardNo=0 hidden=true/>
            <PokerCard bind:this={communityCards[1]} cardNo=1 hidden=true/>
            <PokerCard bind:this={communityCards[2]} cardNo=2 hidden=true/>
            <PokerCard bind:this={communityCards[3]} cardNo=3 hidden=true/>
            <PokerCard bind:this={communityCards[4]} cardNo=4 hidden=true/>

            {#if bestHandDescription != null}
            <span class="myBestHandDescription">
                {bestHandDescription}
                <ion-progress-bar value={bestHandPercent}></ion-progress-bar>
            </span>
            {/if}

            <BuyInPanel bind:this={buyInPanel} on:buyIn={onBuyIn} on:buyInCancelled={() => { showSitButtons(true); }} minBuyIn={tableObj.min_buy_in} maxBuyIn={tableObj.max_buy_in}/>
            <ProfilePanel bind:this={profilePanel} on:sendInvite={onSendInvite} />
            <FriendsPanel bind:this={friendsPanel} />
            <SelectGiftPanel bind:this={selectGiftPanel} on:giftSelected={onGiftSelected} />
            <FriendshipInvitation bind:this={friendshipInvitation} 
                on:accept={(event) => {onInvitationAnswer("accept", event.detail.originalSender);}} 
                on:reject={(event) => {onInvitationAnswer("reject", event.detail.originalSender);}} 
                on:block={(event) => {onInvitationAnswer("block", event.detail.originalSender);}} />

            {#if myPlayer != null && myPlayer.isPlaying() == true && activePlayer != undefined && myPlayer.getStatus() != "allIn"}      <!-- I am active in this round and we're not in waiting or showdown stages and I'm not all-in already, so I should get some controls -->
                {#if requiredBet == 0 || myPlayer.getBet() == requiredBet}      <!-- I'am able to check or bet-->
                    {#if myPlayer == activePlayer}                              <!-- I'am the currently active playere-->
                        {#if autoAction == null}
                        <div class="hbox" style="position: absolute; left: 240px; bottom: -40px;">
                            <ion-button bind:this={foldButton} on:click={()=>requestFold()}>Fold</ion-button>
                            <ion-button bind:this={checkCallButton} on:click={()=>requestCheck()}>Check</ion-button>
                            <ion-button bind:this={betRaiseButton} on:click={()=>requestBetRaise()}>Bet</ion-button>
                            <ion-input bind:this={betRaiseAmount} type="number" size="10" value={getMinBet()} min={getMinBet()} max={getMaxBet()} step={1}></ion-input>
                            <ion-button bind:this={allInButton} on:click={()=>requestAllIn()}>All In</ion-button>
                        </div>
                        {/if}
                    {:else}                                                     <!-- I'am waiting for my turn-->
                    <div class="hbox" style="position: absolute; left: 120px; bottom: -40px;">
                        <ion-item><ion-toggle bind:this={foldToggle} on:ionChange={(event)=> setAutoAction("fold", event.target.checked)}></ion-toggle><ion-label>Fold</ion-label></ion-item>
                        <ion-item><ion-toggle bind:this={checkFoldToggle} on:ionChange={(event)=> setAutoAction("checkFold", event.target.checked)}></ion-toggle><ion-label>Check/Fold</ion-label></ion-item>
                        <ion-item><ion-toggle bind:this={checkToggle} on:ionChange={(event)=> setAutoAction("check", event.target.checked)}></ion-toggle><ion-label>Check</ion-label></ion-item>
                        <ion-item><ion-toggle bind:this={callAnyToggle} on:ionChange={(event)=> setAutoAction("callAny", event.target.checked)}></ion-toggle><ion-label>Call Any</ion-label></ion-item>
                    </div>
                    {/if}
                {:else}                                                         <!-- I have to call or rise-->
                    {#if myPlayer.getChips() > requiredBet - myPlayer.getBet()}     <!-- Calling won't put me into all-in-->
                        {#if myPlayer == activePlayer}                              <!-- I'am the currently active playere-->
                            {#if autoAction == null}
                            <div class="hbox" style="position: absolute; left: 240px; bottom: -40px;">
                                <ion-button bind:this={foldButton} on:click={()=>requestFold()}>Fold</ion-button>
                                <ion-button bind:this={checkCallButton} on:click={()=>requestCall()}>Call</ion-button>
                                {#if myPlayer.getChips() > getMinBet()} 
                                <ion-button bind:this={betRaiseButton} on:click={()=>requestBetRaise()}>Raise</ion-button>
                                <ion-input bind:this={betRaiseAmount} type="number" size="10" value={getMinBet()} min={getMinBet()} max={getMaxBet()} step={1}></ion-input>
                                {:else}
                                <ion-button bind:this={betRaiseButton} on:click={()=>requestBetRaise()} disabled>Raise</ion-button>
                                <ion-input bind:this={betRaiseAmount} type="number" size="10" value={getMinBet()} min={getMinBet()} max={getMaxBet()} step={1} disabled></ion-input>
                                {/if}
                                <ion-button bind:this={allInButton} on:click={()=>requestAllIn()}>All In</ion-button>
                            </div>  
                            {/if}      
                        {:else}                                                     <!-- I'am waiting for my turn-->
                        <div class="hbox" style="position: absolute; left: 170px; bottom: -40px;">
                            <ion-item><ion-toggle bind:this={foldToggle} on:ionChange={(event)=> setAutoAction("fold", event.target.checked)}></ion-toggle><ion-label>Fold</ion-label></ion-item>
                            <ion-item><ion-toggle bind:this={callToggle} on:ionChange={(event)=> setAutoAction("call", event.target.checked)}></ion-toggle><ion-label>Call</ion-label></ion-item>
                            <ion-item><ion-toggle bind:this={callAnyToggle} on:ionChange={(event)=> setAutoAction("callAny", event.target.checked)}></ion-toggle><ion-label>Call Any</ion-label></ion-item>
                        </div>
                        {/if}
                    {:else}                                                     <!-- Calling would put me into all-in-->
                        {#if myPlayer == activePlayer}                              <!-- I'am the currently active playere-->
                            {#if autoAction == null}
                            <div class="hbox" style="position: absolute; left: 320px; bottom: -40px;">
                                <ion-button bind:this={foldButton} on:click={()=>requestFold()}>Fold</ion-button>
                                <ion-button bind:this={allInButton} on:click={()=>requestAllIn()}>All In</ion-button>
                            </div>
                            {/if}
                        {:else}                                                     <!-- I'am waiting for my turn-->
                        <div class="hbox" style="position: absolute; left: 320px; bottom: -40px;">
                            <ion-item><ion-toggle bind:this={foldToggle} on:ionChange={(event)=> setAutoAction("fold", event.target.checked)}></ion-toggle><ion-label>Fold</ion-label></ion-item>
                            <ion-item><ion-toggle bind:this={allInToggle} on:ionChange={(event)=> setAutoAction("allIn", event.target.checked)}></ion-toggle><ion-label>All In</ion-label></ion-item>
                        </div>
                        {/if}
                    {/if}
                {/if}
            {:else}
                {#if roundOver == true && myPlayer && myPlayer.isPlaying() == true && (stage == "preFlop" || stage == "flop" || stage == "turn")}
                    <div class="hbox" style="position: absolute; left: 340px; bottom: -40px;">
                        <ion-button on:click={()=>requestRabbits()}>Show Rabbits</ion-button>
                    </div>
                {/if}
            {/if}
        </div>
        
        <div style="width: 300px; height: 100%;" class="vbox">
            <ion-tile>Spectators</ion-tile>
            {#each spectators as spectator, i}
                <div class="hbox" style="align-items: center; width: 100%">
                    <img style="width: 50px; height: 50px;" src={spectator.photo} on:click={() => { onOpenProfilePanel({detail: {user_id: spectator.id, name: spectator.name, avatar: spectator.photo}}); }} alt={spectator.id}>
                    <span style="width: 120px; text-align: left; margin-left: 10px;">{spectator.name}</span>
                </div>
             {/each}
        </div>
    </div>
    {/if}
</ion-content>

<ion-footer>
    {#if isConnected}
    <div style="display: flex; justify-content: flex-end; margin-right: 8px; margin-bottom: -25px">
        <ion-button on:click={openFriendsPanel} >Friends</ion-button>    
    </div>
    {/if}
    <Chat  bind:this={chat} type="table" casinoId={casinoId} tableId={tableId} />
</ion-footer>

<style>
    .container {
        position: relative;
        margin: 0px;
        width: 100%;
    }

    .sfsConnected {
        position: relative;
        font-size: smaller;
        color: green;
    }

    .sfsDisconnected {
        position: relative;
        font-size: smaller;
        color: red;
    }

    .tableImage {
        width: 800px;
        height: 600px;
        min-width: 800px;
        min-height: 600px;
        margin: 1em;
    }

    .myBestHandDescription {
        position: absolute; 
        color: yellow;
        text-align: center;
        left: 325px;
        width: 150px; 
        bottom: 30px;
    }

    .bbjp {
        position: absolute; 
        color: white;
        top: 25px;
        left: 20px;
    }

    .bbjpAward {
        position: absolute; 
        color: red;
        font-size: large;
        top: 80px;
        left: 330px;
    }
</style>